import React from 'react';
import { ArrowLeft, Shield, Lock, Eye, Database, Mail, Server } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const DatenschutzPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-green-50 to-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-green-800 text-white py-12">
        <div className="container mx-auto px-4">
          <Link to="/">
            <Button variant="ghost" className="text-white hover:bg-white/20 mb-4">
              <ArrowLeft className="h-4 w-4 mr-2" /> Zurück zur Startseite
            </Button>
          </Link>
          <div className="flex items-center gap-4">
            <Shield className="h-12 w-12" />
            <div>
              <h1 className="text-3xl font-bold">Datenschutzhinweise</h1>
              <p className="text-green-100">Dom's Pfotenexpress - Pfotenflatrate</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg p-8 space-y-8">
          
          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4 flex items-center">
              <Database className="h-5 w-5 mr-2" /> 1. Verantwortlicher
            </h2>
            <div className="text-gray-700 bg-gray-50 p-4 rounded-lg">
              <p>Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:</p>
              <p className="mt-3">
                <strong>Dom's Pfotenexpress</strong><br />
                Inhaber: Dominique Ewerling<br />
                Sternstraße 1<br />
                58089 Hagen<br />
                Telefon: 01573 969 69 42<br />
                E-Mail: doms.pfotenexpress@gmail.com
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4 flex items-center">
              <Eye className="h-5 w-5 mr-2" /> 2. Erhobene personenbezogene Daten
            </h2>
            <div className="text-gray-700 space-y-3">
              <p>Im Rahmen der Nutzung unserer Dienste und insbesondere bei der Registrierung zur Pfotenflatrate erheben wir folgende personenbezogene Daten:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Name, Vorname</li>
                <li>Anschrift (Straße, Hausnummer, PLZ, Ort)</li>
                <li>E-Mail-Adresse</li>
                <li>Telefonnummer</li>
                <li>Angaben zu Ihren Haustieren (Name, Art, Besonderheiten)</li>
                <li>Zahlungsinformationen (werden von unserem Zahlungsdienstleister Stripe verarbeitet)</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4">3. Zweck der Datenverarbeitung</h2>
            <div className="text-gray-700 space-y-3">
              <p>Wir verarbeiten Ihre Daten zu folgenden Zwecken:</p>
              <div className="grid md:grid-cols-2 gap-3 mt-3">
                <div className="bg-green-50 p-3 rounded-lg">
                  <p className="font-semibold text-green-700">Vertragserfüllung</p>
                  <p className="text-sm">Art. 6 Abs. 1 lit. b DSGVO</p>
                </div>
                <div className="bg-green-50 p-3 rounded-lg">
                  <p className="font-semibold text-green-700">Terminkoordination</p>
                  <p className="text-sm">Kommunikation bezüglich der Transporte</p>
                </div>
                <div className="bg-green-50 p-3 rounded-lg">
                  <p className="font-semibold text-green-700">Abrechnung</p>
                  <p className="text-sm">Zahlungsabwicklung</p>
                </div>
                <div className="bg-green-50 p-3 rounded-lg">
                  <p className="font-semibold text-green-700">Gesetzliche Pflichten</p>
                  <p className="text-sm">Art. 6 Abs. 1 lit. c DSGVO</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4 flex items-center">
              <Server className="h-5 w-5 mr-2" /> 4. Weitergabe an Dritte
            </h2>
            <div className="text-gray-700 space-y-3">
              <p>Ihre Daten werden nur an Dritte weitergegeben, soweit dies zur Vertragserfüllung erforderlich ist oder Sie eingewilligt haben:</p>
              <div className="space-y-3 mt-3">
                <div className="border-l-4 border-blue-500 pl-4 py-2">
                  <p className="font-semibold">Stripe, Inc.</p>
                  <p className="text-sm text-gray-600">Zahlungsabwicklung (Privacy Shield zertifiziert)</p>
                  <a href="https://stripe.com/privacy" target="_blank" rel="noreferrer" className="text-blue-600 text-sm hover:underline">stripe.com/privacy</a>
                </div>
                <div className="border-l-4 border-purple-500 pl-4 py-2">
                  <p className="font-semibold">Resend</p>
                  <p className="text-sm text-gray-600">Versand von transaktionalen E-Mails (Bestätigungen, Vertragsdokumente)</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4">4a. Datenverarbeitung im Rahmen des Haustiertransports</h2>
            <div className="text-gray-700 space-y-3">
              <p>Für die Durchführung unserer Transportdienstleistungen verarbeiten wir zusätzlich:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Transportdaten:</strong> Abhol- und Zieladressen, Datum und Uhrzeit der Transporte</li>
                <li><strong>Tierarzt-/Klinikdaten:</strong> Name und Anschrift des Tierarztes oder der Tierklinik</li>
                <li><strong>Transportprotokolle:</strong> Dokumentation der durchgeführten Fahrten zur Abrechnung</li>
                <li><strong>Besondere Hinweise:</strong> Medizinische Besonderheiten Ihres Tieres, die für einen sicheren Transport relevant sind</li>
              </ul>
              <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-200 mt-4">
                <p className="font-semibold text-yellow-800">Hinweis zur Vertraulichkeit:</p>
                <p className="text-sm mt-2">Alle Informationen zu Ihrem Tier und den Transportfahrten werden vertraulich behandelt und ausschließlich für die Vertragserfüllung verwendet. Tierärztliche Informationen werden nicht an Dritte weitergegeben.</p>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4">5. Speicherdauer</h2>
            <div className="text-gray-700 space-y-3">
              <p>Wir speichern Ihre personenbezogenen Daten nur so lange, wie es für die Erfüllung des Vertragszwecks erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen:</p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Vertragsdaten:</strong> Für die Dauer des Vertragsverhältnisses + 3 Jahre</li>
                <li><strong>Rechnungsdaten:</strong> 10 Jahre (steuerrechtliche Aufbewahrungspflicht)</li>
                <li>Nach Ablauf der Fristen werden Ihre Daten gelöscht</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4">6. Ihre Rechte</h2>
            <div className="text-gray-700 space-y-3">
              <p>Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:</p>
              <div className="grid md:grid-cols-2 gap-3 mt-3">
                <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                  <p className="font-semibold text-blue-700">Auskunftsrecht</p>
                  <p className="text-sm">Art. 15 DSGVO - Auskunft über gespeicherte Daten</p>
                </div>
                <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                  <p className="font-semibold text-blue-700">Berichtigungsrecht</p>
                  <p className="text-sm">Art. 16 DSGVO - Berichtigung unrichtiger Daten</p>
                </div>
                <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                  <p className="font-semibold text-blue-700">Löschungsrecht</p>
                  <p className="text-sm">Art. 17 DSGVO - Löschung Ihrer Daten</p>
                </div>
                <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                  <p className="font-semibold text-blue-700">Einschränkung</p>
                  <p className="text-sm">Art. 18 DSGVO - Einschränkung der Verarbeitung</p>
                </div>
                <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                  <p className="font-semibold text-blue-700">Datenübertragbarkeit</p>
                  <p className="text-sm">Art. 20 DSGVO</p>
                </div>
                <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                  <p className="font-semibold text-blue-700">Widerspruchsrecht</p>
                  <p className="text-sm">Art. 21 DSGVO</p>
                </div>
              </div>
              <p className="mt-4 bg-yellow-50 p-3 rounded-lg border border-yellow-200">
                <strong>Beschwerderecht:</strong> Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4">7. Cookies und Website-Analyse</h2>
            <div className="text-gray-700 space-y-3">
              <p>Unsere Website verwendet technisch notwendige Cookies, um die Funktionalität der Website sicherzustellen. Diese Cookies speichern keine personenbezogenen Daten.</p>
              <p>Wir verwenden keine Tracking- oder Analyse-Cookies ohne Ihre ausdrückliche Einwilligung.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4 flex items-center">
              <Lock className="h-5 w-5 mr-2" /> 8. Datensicherheit
            </h2>
            <div className="text-gray-700 space-y-3">
              <p>Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten gegen zufällige oder vorsätzliche Manipulation, Verlust, Zerstörung oder gegen den Zugriff unberechtigter Personen zu schützen.</p>
              <div className="bg-green-50 p-4 rounded-lg mt-3 flex items-center gap-3">
                <Lock className="h-8 w-8 text-green-600" />
                <div>
                  <p className="font-semibold text-green-700">SSL/TLS Verschlüsselung</p>
                  <p className="text-sm">Alle Daten werden verschlüsselt über HTTPS übertragen</p>
                </div>
              </div>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4">9. Änderungen der Datenschutzhinweise</h2>
            <div className="text-gray-700">
              <p>Wir behalten uns vor, diese Datenschutzhinweise anzupassen, um sie an geänderte Rechtslagen oder Änderungen unserer Dienste anzupassen. Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-bold text-green-600 mb-4 flex items-center">
              <Mail className="h-5 w-5 mr-2" /> 10. Kontakt für Datenschutzanfragen
            </h2>
            <div className="text-gray-700 bg-gray-50 p-4 rounded-lg">
              <p>Bei Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte wenden Sie sich bitte an:</p>
              <p className="mt-3">
                Dom's Pfotenexpress<br />
                Datenschutz<br />
                Sternstraße 1, 58089 Hagen<br />
                E-Mail: <a href="mailto:doms.pfotenexpress@gmail.com" className="text-green-600 hover:underline">doms.pfotenexpress@gmail.com</a>
              </p>
            </div>
          </section>

          {/* Footer */}
          <div className="border-t pt-6 mt-8 text-center text-gray-500 text-sm">
            <p>Dom's Pfotenexpress · Inhaber: Dominique Ewerling · Sternstraße 1 · 58089 Hagen</p>
            <p>Tel: 01573 969 69 42 · E-Mail: doms.pfotenexpress@gmail.com</p>
            <p className="mt-2">Stand: Januar 2026</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
